export const infoStyles = {
  display: 'flex',
  alignItems: 'center',
  mt: 1,
  pl: 1,
  pb: 1,
  justifyContent: 'space-around',
};

export const imageStyles = {
  width: 400,
  height: 500,
  objectFit: 'contain',
};

export const cardStyles = {
  display: 'flex',
  justifyContent: 'space-between',
};

export const boxStyles = {
  display: 'flex',
  flexDirection: 'column',
  width: 500,
};

export const cardContentStyles = {
  flex: '1 0 auto',
  mr: 4,
};

export const typographyStyles = {
  mt: 1,
};

export const buttonStyles = {
  mt: 6,
};
